/* eslint-disable no-use-before-define */
import { Component } from 'react';
import SystemAlertItem from '../../Domain/SystemAlertItem';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import SystemAlertService from '../../Services/SystemAlertService';

class EditSystemAlertWindowDescription extends Component
{
  static titleForCreate = 'Create System Alert';
  static titleForEdit = 'Edit System Alert';
  static ComponentName = 'SystemAlert';

  static itemType = SystemAlertItem;
  static serviceFunction = (edited) => SystemAlertService.UpsertSystemAlert
    ? SystemAlertService.UpsertSystemAlert(edited)
    : null;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Title',
          label: 'Title*',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Message',
          label: 'Message*',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: (e) => ValidityHelper.forRequiredAndMaxLengthField(e, 2000),
        },
        {
          fieldName: 'LinkUrl',
          label: 'Link URL',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'SeverityLevel',
          label: 'Severity Level* ',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditSystemAlertWindowDescription.getSeverityLevelSelectOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'DisplayOrder',
          label: 'Display Order',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'StartAt',
          label: 'Start At (UTC)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredDateTime,
          placeholder: 'YYYY-MM-DD HH:MM',
        },
        {
          fieldName: 'PopupDateTime',
          label: 'Popup DateTime (UTC)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forDateTimeOrEmpty,
          placeholder: 'YYYY-MM-DD HH:MM',
        },
        {
          fieldName: 'LengthHours',
          label: 'Length (hours)',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'AutoDeletionAfterExpiration',
          label: 'Auto Deletion After Expiration',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'IsDismissible',
          label: 'Is Dismissible?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },

      ],
    },
  ];

  static getSeverityLevelSelectOptions ()
  {
    return [
      {
        label: 'Critical (1)',
        value: '1',
        disabled: false,
      },
      {
        label: 'Warning (2)',
        value: '2',
        disabled: false,
      },
      {
        label: 'Info (3)',
        value: '3',
        disabled: false,
      }
    ];
  }


}

export default EditSystemAlertWindowDescription;
